import type { DocumentWithRecordMetadata } from 'korint-sdk';

/**
 * Groups documents by category, keeping only the latest version of each type
 * @param documents Array of documents to filter
 * @returns Array of the latest documents for each document type
 */
export const getLatestDocumentsByType = (
  documents: DocumentWithRecordMetadata[],
): DocumentWithRecordMetadata[] => {
  if (!documents.length) return [];

  const documentsByType = documents.reduce(
    (acc, document) => {
      if (document.category) {
        const docType = document.category as string;
        if (!acc[docType] || new Date(acc[docType].createdAt) < new Date(document.createdAt)) {
          acc[docType] = document;
        }
      }
      return acc;
    },
    {} as Record<string, DocumentWithRecordMetadata>,
  );

  return Object.values(documentsByType);
};
